import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'container-public-tracking-layout',
  templateUrl: './public-tracking-layout.component.html',
  styleUrls: ['./public-tracking-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicTrackingLayoutComponent {}
